// Generated from BaserowFormula.g4 by ANTLR 4.9
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by BaserowFormula.
export default class BaserowFormulaListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by BaserowFormula#root.
	enterRoot(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#root.
	exitRoot(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#FieldReference.
	enterFieldReference(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#FieldReference.
	exitFieldReference(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#StringLiteral.
	enterStringLiteral(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#StringLiteral.
	exitStringLiteral(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#Brackets.
	enterBrackets(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#Brackets.
	exitBrackets(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#BooleanLiteral.
	enterBooleanLiteral(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#BooleanLiteral.
	exitBooleanLiteral(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#RightWhitespaceOrComments.
	enterRightWhitespaceOrComments(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#RightWhitespaceOrComments.
	exitRightWhitespaceOrComments(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#DecimalLiteral.
	enterDecimalLiteral(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#DecimalLiteral.
	exitDecimalLiteral(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#LeftWhitespaceOrComments.
	enterLeftWhitespaceOrComments(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#LeftWhitespaceOrComments.
	exitLeftWhitespaceOrComments(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#FunctionCall.
	enterFunctionCall(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#FunctionCall.
	exitFunctionCall(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#FieldByIdReference.
	enterFieldByIdReference(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#FieldByIdReference.
	exitFieldByIdReference(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#LookupFieldReference.
	enterLookupFieldReference(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#LookupFieldReference.
	exitLookupFieldReference(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#IntegerLiteral.
	enterIntegerLiteral(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#IntegerLiteral.
	exitIntegerLiteral(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#BinaryOp.
	enterBinaryOp(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#BinaryOp.
	exitBinaryOp(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#ws_or_comment.
	enterWs_or_comment(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#ws_or_comment.
	exitWs_or_comment(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#func_name.
	enterFunc_name(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#func_name.
	exitFunc_name(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#field_reference.
	enterField_reference(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#field_reference.
	exitField_reference(ctx) {
	}


	// Enter a parse tree produced by BaserowFormula#identifier.
	enterIdentifier(ctx) {
	}

	// Exit a parse tree produced by BaserowFormula#identifier.
	exitIdentifier(ctx) {
	}



}